import * as Yup from 'yup';

import { validateField, ValidationType } from './formValidation';
import {
    DocumentTemplateFormInterface,
    OrganizationAgentFormInterface,
    OrganizationAgreementFormInterface,
} from 'types';

export const organizationDocumentTemplateFormInitialValues: DocumentTemplateFormInterface = {
    name_en: '',
    name_fr: '',
    description_en: '',
    description_fr: '',
    is_form: false,
    fields_json: '',
    document_type: '',
    template: null,
    sample: null,
};

export const organizationDocumentTemplateFormValidationSchema = Yup.object().shape(
    {
        name_en: validateField(ValidationType.STRING, false).when('name_fr', {
            is: (val: string) => !val,
            then: (schema) => schema.required('At least one name (EN or FR) is required'),
        }),
        name_fr: validateField(ValidationType.STRING, false).when('name_en', {
            is: (val: string) => !val,
            then: (schema) => schema.required('At least one name (EN or FR) is required'),
        }),
        description_en: validateField(ValidationType.STRING, false).when('description_fr', {
            is: (val: string) => !val,
            then: (schema) => schema.required('At least one description (EN or FR) is required'),
        }),
        description_fr: validateField(ValidationType.STRING, false).when('description_en', {
            is: (val: string) => !val,
            then: (schema) => schema.required('At least one description (EN or FR) is required'),
        }),
        // is_form: validateField(ValidationType.BOOLEAN_VALUE),
        // fields_json: Yup.string().when('is_form', {
        //     is: true,
        //     then: (schema) =>
        //         schema
        //             .trim()
        //             .required('This is a required field')
        //             .test('valid-json', 'Enter valid JSON', (value) => {
        //                 if (!value) return false;
        //                 try {
        //                     JSON.parse(value);
        //                     return true;
        //                 } catch {
        //                     return false;
        //                 }
        //             }),
        //     otherwise: (schema) => schema.nullable(),
        // }),
        document_type: validateField(ValidationType.STRING),
        template: Yup.mixed<File>().nullable(),
        sample: Yup.mixed<File>().nullable(),
    },
    [
        ['name_en', 'name_fr'],
        ['description_en', 'description_fr'],
    ]
);

export const organizationAgreementFormInitialValues: OrganizationAgreementFormInterface = {
    client_id: null,
    template_id: null,
    resource_type: null,
    agreement_type: null,
    party_b_signatory_email: null,
    party_a_agent_id: null,
    party_a_signatory_name: null,
    party_a_signatory_title: null,
    party_a_signature_html: null,
    effective_date: null,
    expiry_date: null,
};

export const organizationAgreementFormValidationSchema = Yup.object({
    template_id: validateField(ValidationType.STRING),
});

export const organizationAgentFormInitialValues: OrganizationAgentFormInterface = {
    firstname: '',
    lastname: '',
    email: '',
    role: '',
};

export const organizationAgentFormValidationSchema = Yup.object({
    firstname: validateField(ValidationType.STRING),
    lastname: validateField(ValidationType.STRING),
    email: validateField(ValidationType.EMAIL),
    role: validateField(ValidationType.STRING),
});

export const b2bAgreementFormInitialValues: OrganizationAgreementFormInterface = {
    client_id: null,
    template_id: null,
    resource_type: 'ORG_TO_ORG_RETAINER_AGREEMENT',
    agreement_type: null,
    party_b_signatory_email: null,
    party_a_agent_id: null,
    party_a_signatory_name: '',
    party_a_signatory_title: '',
    party_a_signature_html: null,
    effective_date: null,
    expiry_date: null,
};

export const b2bAgreementFormValidationSchema = Yup.object({
    template_id: Yup.number().nullable().required('Template is required'),
    party_b_signatory_email: Yup.string()
        .email('Invalid email address')
        .nullable()
        .required('Counter-party signatory email is required'),
});
